<template>
    <el-container>
        <el-header>
            <div class="nav">
                <div class="nav-menu">
                    <img class="logo" src="@/assets/img/logo.png" alt="">
                    <div class="menu-item">
                        <router-link to="/plugin/plugin">应用购买</router-link>
                        <div class="bottom"></div>
                    </div>
                    <div class="menu-item active">
                        <router-link to="/dashboard">管理中心</router-link>
                        <div class="bottom"></div>
                    </div>
                    <div class="login-status">
                        <span style="margin-right: 20px;color: #bfbcb3">商盟版</span>
                        <span>
                            <router-link v-if="user.mobile > 0" to="/dashboard/user/index" style="cursor: pointer">{{user.mobile}}</router-link>
                            <router-link to="/passport/login" v-else>登录</router-link>
                        </span>
                        <span style="margin: 0 15px;">|</span>
                        <span @click="logout" style="cursor: pointer">退出</span>
                    </div>
                </div>
            </div>
        </el-header>
        <el-container>
            <el-aside width="140px">
                <div class="menu-down" @click="openMenu()" v-if="show">
                    <img src="@/assets/img/xia.png" alt="">
                </div>
                <div class="menu-down" @click="closeMenu()" v-if="!show">
                    <img src="@/assets/img/shang.png" alt="">
                </div>
                <div class="aside">
                    <el-scrollbar style="height: 100%">
                        <el-menu :router="true"
                                 text-color="#bbbbbb"
                                 background-color="#fff"
                                 :default-active='route'
                                 v-show="!show"
                                 active-text-color="#2e9fff">
                            <el-menu-item-group>
                                <el-menu-item v-for="item in userMenus"
                                              :key="item.route"
                                              :index="item.route" :route="item.route"
                                              @click="changeTab(item.name, item.route)">
                                    <div flex="cross:center" style="height: 100%">
                                        <img :src="item.active_icon" class="menu-icon" alt="" v-if="name == item.name">
                                        <img :src="item.icon" class="menu-icon" alt="" v-else>
                                        <span @click="closeMenu()">{{item.name}}</span>
                                    </div>
                                </el-menu-item>
                            </el-menu-item-group>
                            <el-menu-item-group v-if="adminMenus">
                                <template slot="title">管理员</template>
                                <el-menu-item v-for="item in adminMenus"
                                              :key="item.route"
                                              :index="item.route" :route="item.route"
                                              @click="changeTab(item.name, item.route)">
                                    <div flex="cross:center" style="height: 100%">
                                        <img :src="item.active_icon" class="menu-icon" alt="" v-if="name == item.name">
                                        <img :src="item.icon" class="menu-icon" alt="" v-else>
                                        <span @click="closeMenu()">{{item.name}}</span>
                                    </div>
                                </el-menu-item>
                            </el-menu-item-group>
                        </el-menu>
                    </el-scrollbar>
                </div>
            </el-aside>
            <el-main style="padding-top: 0; padding-bottom: 0">
                <router-view/>
                <div style="text-align: center;padding: 10px;">
                    <a href="https://www.zjhejiang.com" target="_blank" style="color: #909090; text-decoration: none">浙江禾匠信息科技有限公司&copy;2018</a>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<style scoped>
    .el-aside {
        margin-top: 15px;
        border-radius: 15px;
        background-color: #fff;
    }

    .aside {
        position: fixed;
        width: 140px;
        overflow-y: auto;
        padding: 24px 0;
        height: 90%;
        background-color: #fff;
        border-radius: 15px;
    }

    .el-header {
        padding: 0;
    }

    .logo {
        margin-top: 18px;
        margin-right: 20px;
        float: left;
        height: 24px;
        width: 114px;
    }

    .nav {
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        background-color: #10ab7b;
        position: fixed;
        width: 100%;
        z-index: 99;
        top: 0;
    }

    .nav a {
        color: #fff;
    }

    .nav-menu {
        width: 1200px;
        height: 100%;
        margin: 0 auto;
    }

    .menu-item.active a {
        color: #0a3020;
    }

    .active .bottom {
        height: 4px;
        width: 20px;
        border-radius: 2px;
        background-color: #0a3020;
        margin: -4px auto 0;
    }

    .menu-item {
        float: left;
        margin-left: 80px;
    }

    .login-status {
        float: right;
        color: #fff;
    }

    .el-header + .el-container {
        width: 1200px;
        margin: 0 auto;
    }

    .user-icon {
        height: 28px;
        width: 28px;
    }

    .el-menu {
        border: 0;
    }

    .el-menu-item {
        text-align: center;
        font-size: 12px;
        line-height: normal;
    }

    .menu-icon {
        height: 20px;
        width: 20px;
        margin-right: 12px;
    }

    .out {
        text-align: center;
        margin-bottom: 44px;
        cursor: pointer;
    }

    .el-scrollbar__wrap {
        overflow-x: hidden;
    }

    .out .el-button {
        padding: 0;
        border: 0;
    }

    .menu-down {
        display: none;
    }

    @media screen and (max-width: 767px) {
        .nav {
            width: auto;
            left: 0;
            right: 0;
        }

        .nav-menu {
            width: 100%;
        }

        .menu-item {
            margin-left: 1rem;
        }

        .login-status {
            margin-right: 0.5rem
        }

        .login-status span:nth-child(2) {
            margin: 0 0.5rem !important
        }

        .el-aside {
            width: 7rem !important;
            margin-top: 0;
            background-color: #F4F8F9;
        }

        .el-menu-item {
            height: 1.5rem;
            margin-bottom: 1rem;
        }

        .aside {
            position: absolute;
            top: 60px;
            left: 50%;
            margin-top: 2.5rem;
            margin-left: -3.5rem;
            padding: 0;
            height: auto;
            width: 7rem;
            z-index: 5;
            box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.15);
            -webkit-box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.15);
        }

        .logo, .menu-icon {
            display: none;
        }

        .el-menu-item.is-active {
            display: block;
        }

        .menu-down {
            font-size: 17px;
            position: absolute;
            top: 60px;
            left: 0;
            display: block;
            z-index: 5;
            padding-left: 63%;
            margin-top: 0.5rem;
            height: 2rem;
            line-height: 2.25rem;
        }

        .el-menu {
            width: 7rem !important;
        }

        .el-main {
            margin-top: 1rem;
            padding: 0.5rem;
            margin-left: -7rem;
        }

        .el-header + .el-container {
            width: 100%;
        }

        .el-main >>> h1 {
            height: 2rem;
            line-height: 2rem;
            margin: -0.5rem 0 0.5rem;
            width: 100%;
            text-align: center;
        }

        .el-main >>> .el-card__body {
            padding: 0.5rem;
        }

        .el-main >>> .el-pagination {
            white-space: normal;
        }

        .el-main >>> .el-table {
            font-size: 12px;
        }

        .el-main >>> .el-dialog {
            width: 90%;
        }
    }
</style>

<script>
export default {
    name: 'dashboard',
    data() {
        return {
            show: false,
            menuShow: true,
            name: '',
            route: '',
            userMenus: [
                {
                    name: '账户信息',
                    route: '/dashboard/user/index',
                    icon: require('@/assets/img/user.png'),
                    active_icon: require('@/assets/img/user-on.png')
                },
                {
                    name: '站点列表',
                    route: '/dashboard/host/index',
                    icon: require('@/assets/img/list.png'),
                    active_icon: require('@/assets/img/list-on.png')
                },
                {
                    name: '应用订单',
                    route: '/dashboard/app-order/index',
                    icon: require('@/assets/img/order.png'),
                    active_icon: require('@/assets/img/order-on.png')
                },
                {
                    name: '插件订单',
                    route: '/dashboard/plugin-order/index',
                    icon: require('@/assets/img/order.png'),
                    active_icon: require('@/assets/img/order-on.png')
                },
                {
                    name: '商盟管理 ',
                    route: '/dashboard/mch/index',
                    icon: require('@/assets/img/user-mgt.png'),
                    active_icon: require('@/assets/img/user-mgt-on.png')
                }
            ],
            adminMenus: null,
            user: {mobile: null},
            loading: false
        }
    },
    created() {
        this.$store.dispatch('getUser').then(e => {
            if (e && e.admin) {
                this.$store.dispatch('getAdminNavs').then(e => {
                    this.adminMenus = e
                })
            }
        })
        this.loadData()
        this.route = window.location.href.split('user')[1]
        if (this.route === '/dashboard/') {
            this.route = '/dashboard/user/index'
        } else if (this.route === '/dashboard/admin/') {
            this.route = '/dashboard/admin/user/index'
        }
        for (let i = 0; i < this.userMenus.length; i++) {
            if (this.userMenus[i].route === this.route) {
                this.name = this.userMenus[i].name
            }
        }
    },
    mounted() {
        if (window.innerWidth < 768) {
            this.show = true
        }
    },
    methods: {
        logout() {
            this.$store.dispatch('userLogout')
            this.$router.go({
                path: '/passport/login'
            })
        },
        changeTab(name, route) {
            this.name = name
            this.route = route
        },
        openMenu() {
            this.show = false
            this.menuShow = false
        },
        closeMenu() {
            if (window.innerWidth < 768) {
                this.show = true
                this.menuShow = true
            }
        },
        loadData() {
            this.loading = true
            this.$store.dispatch('getUser').then(e => {
                this.loading = false
                this.user = e
            })
        }
    }
}
</script>
